<template>
	<div>
        <div class="row" v-if="!(ready || urlHasToken )">
            <div class="col-12 mb-4">
                <div
                    class="card"
                    style="width: 18rem; margin: 40px auto 0"
                >
                    <div class="card-body text-center">
                        <!--b-icon
                            icon="check-circle-fill"
                            class="text-success mb-2"
                            style="font-size: 1.5rem"
                        /-->
                        <h5 class="card-title">{{ $t("enter-check-in-code") }}</h5>
                        <p class="card-text">
                            <TextInput v-model="token" :label="$t('code')" :placeholder="$t('eg-code')" class="font-bold"></TextInput>
                        </p>
                            <button class="btn btn-primary" @click="tryCheckin()">{{ $t("done") }}</button>
                    </div>
                </div>
            </div>
        </div>
		<template v-if="ready">
			<template v-if="checkedin">
				<div class="row">
					<div class="col-12 mb-4">
						<div
							class="card"
							style="width: 18rem; margin: 40px auto 0"
						>
							<div class="card-body text-center">
								<b-icon
									icon="check-circle-fill"
									class="text-success mb-2"
									style="font-size: 1.5rem"
								/>
								<h5 class="card-title">{{ $t("checked-in") }}</h5>
								<p class="card-text">
									{{ $t("you-have-successfully-checked-in") }}
								</p>
								<router-link to="/">
									<button class="btn btn-primary">{{ $t("done") }}</button>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>

				<div class="alert alert-danger">
					{{ $t("invalid-token") }}
				</div>
			</template>
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			ready: false,
			checkedin: false,
            token:null,
            urlHasToken: false
		};
	},
	mounted() {
        if(this.$route.params["token"]){
            this.urlHasToken = true;
            this.token = this.$route.params["token"];
            this.tryCheckin();
        }

	},
	methods: {
		tryCheckin() {
			this.$store.commit("showBlockingSpinner");
			this.checkedin = false;
			this.$cfetch(`${this.$settings.APIBaseURL}/attendance/register/checkin`, {
				data: {
					'token': this.token,
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.checkedin = true;
				}
				this.ready = true;
				this.$store.commit("hideBlockingSpinner");
			}).catch(() => {
				this.ready = true;
				this.$store.commit("hideBlockingSpinner");
			});
		}

	}
};
</script>
